import { css } from 'styled-components'

export const Fonts = css``
